const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DOUBLE_DOT_RE = /\.\./;

export function validateEmail(email: string): boolean {
	if (!email) return false;
	if (DOUBLE_DOT_RE.test(email)) return false;
	return EMAIL_RE.test(email);
}
